import React from "react";
import { API_BASE } from "@/lib/api";
import { Copy, ExternalLink, Rss } from "lucide-react";
import { toast } from "sonner";

const FeedCard = ({ title, desc, href, download }) => {
  const copy = () => { navigator.clipboard.writeText(href); toast.success("Feed URL copied"); };
  return (
    <div className="rounded-2xl p-6" style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)" }}>
      <div className="flex items-start justify-between mb-3">
        <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "linear-gradient(135deg, #C9789A, #9B8FBF)" }}>
          <Rss size={15} className="text-cream" />
        </div>
      </div>
      <p className="font-cormorant text-xl text-cream leading-tight">{title}</p>
      <p className="text-sm text-cream/75 mb-4">{desc}</p>

      <div className="rounded-lg p-3 font-mono text-[11px] text-cream/70 bg-black/30 border border-white/10 mb-3 break-all">
        {href}
      </div>
      <div className="flex gap-2 flex-wrap">
        <button onClick={copy} className="inline-flex items-center gap-1.5 h-9 px-4 rounded-lg font-label text-[10px] uppercase tracking-[0.22em] bg-white/5 text-cream hover:bg-white/10">
          <Copy size={12} /> Copy URL
        </button>
        <a
          href={href} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-1.5 h-9 px-4 rounded-lg font-label text-[10px] uppercase tracking-[0.22em] text-cream"
          style={{ background: "linear-gradient(135deg, #C9789A, #9B8FBF)" }}
          download={download}
        >
          <ExternalLink size={12} /> Open / download
        </a>
      </div>
    </div>
  );
};

const AdminFeeds = () => (
  <div data-testid="admin-feeds-page">
    <p className="font-label text-[11px] uppercase tracking-[0.22em] text-rose/70 mb-1">Operations</p>
    <h1 className="font-hero text-3xl text-cream mb-2">Feed manager</h1>
    <p className="text-sm text-cream/75 mb-6 max-w-2xl">Paste these feed URLs into your marketplaces — they update automatically as your catalog changes.</p>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FeedCard
        title="Google Merchant Center"
        desc="Product XML feed compatible with Google Shopping and Google Merchant Center."
        href={`${API_BASE}/feeds/google.xml`}
      />
      <FeedCard
        title="Amazon Seller / Meesho"
        desc="Flat CSV with product info, price, stock and URLs for marketplace imports."
        href={`${API_BASE}/feeds/amazon.csv`}
        download
      />
    </div>
  </div>
);

export default AdminFeeds;
